import BBtn from './BBtn.vue'
import BModal from './BModal.vue'
import BTabs from './BTabs.vue'
import BTab from './BTab.vue'
import BTypeahead from './BTypeahead.vue'
import notifyPlugin from './notify'
import tooltip from './tooltip'

export default {
    install (app) {
        app.component('b-btn', BBtn)
        app.component('b-modal', BModal)
        app.component('b-tabs', BTabs)
        app.component('b-tab', BTab)
        app.component('b-typeahead', BTypeahead)
        app.directive('b-tooltip', tooltip)
        app.use(notifyPlugin)
    }
}

export { default as DatePicker } from './DatePicker.vue'
